<template>
  <div>
    <c-table
      ref="table"
      title="조직도 마스터"
      :editable="editable"
      :columns="grid.columns"
      :data="grid.data"
      selection="multiple"
      rowKey="id"
      :usePaging="false"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn v-if="editable" label="LBLADD" :showLoading="false" icon="add" @btnClicked="add" />
          <c-btn v-if="editable && grid.data.length > 0" label="LBLREMOVE" icon="remove" @btnClicked="removeRow" />
          <c-btn
            v-if="editable && grid.data.length > 0"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="grid.data"
            mappingType="POST"
            label="LBLSAVE"
            icon="save"
            @beforeAction="saveItem"
            @btnCallback="saveCallback" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props }">
        <c-text
          :editable="editable"
          :readonly="true"
          :afterIcon="editable ? [
            { name: 'search', click: true, callbackName: 'searchSenior' },
            { name: 'close', click: true, callbackName: 'removeSenior' }
          ] : null"
          name="seniorId"
          v-model="props.row.seniorName"
          @searchSenior="searchSenior(props.row)"
          @removeSenior="removeSenior(props.row)"
          @dataChange="dataChange(props.row)">
        </c-text>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'safety-org-mst',
  data() {
    return {
      searchParam: {
      },
      grid: {
        columns: [
          {
            name: 'id',
            field: 'id',
            label: '조직 일련번호',
            align: 'left',
            sortable: true,
            style: 'width:10%',
          },
          {
            name: 'parentId',
            field: 'parentId',
            label: '상위 조직 일련번호',
            align: 'left',
            type: 'text',
            sortable: true,
            style: 'width:10%',
          },
          {
            name: 'jobName',
            field: 'jobName',
            label: '조직명',
            align: 'left',
            type: 'text',
            sortable: true,
            style: 'width:12%',
          },
          {
            name: 'level',
            field: 'level',
            label: '레벨',
            align: 'left',
            type: 'number',
            sortable: true,
            style: 'width:4%',
          },
          {
            name: 'sortOrder',
            field: 'sortOrder',
            label: '순번',
            align: 'left',
            type: 'number',
            sortable: true,
            style: 'width:4%',
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '해당부서',
            align: 'center',
            style: 'width:10%',
            sortable: false,
            type: 'dept',
            deptCd: 'deptCd',
            isFirstValue: false,
          },
          {
            name: 'connectionFlag',
            field: 'connectionFlag',
            label: '연결여부',
            align: 'center',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: true,
            style: 'width:7%',
          },
          {
            name: 'multipleFlag',
            field: 'multipleFlag',
            label: '다중유저 등록여부',
            align: 'center',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: true,
            style: 'width:7%',
          },
          {
            name: 'managerFlag',
            field: 'managerFlag',
            label: '관리감독자 여부',
            align: 'center',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: true,
            style: 'width:7%',
          },
          {
            name: 'seniorFlag',
            field: 'seniorFlag',
            label: '선해임 여부',
            align: 'center',
            type: 'check',
            true: 'Y',
            false: 'N',
            sortable: true,
            style: 'width:7%',
          },
          {
            name: 'seniorId',
            field: 'seniorId',
            label: '선해임명',
            align: 'left',
            type: 'custom',
            sortable: true,
            style: 'width:12%',
          },
          {
            name: 'remark',
            field: 'remark',
            label: '비고',
            align: 'left',
            type: 'textarea',
            sortable: true,
            // style: 'width:10%',
          },
        ],
        data: [],
      },
      editable: true,
      isSave: false,
      listUrl: '',
      saveUrl: '',
      deleteUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.sop.org.safetyOrg.list.url;
      this.saveUrl = transactionConfig.sop.org.safetyOrg.save.url;
      this.deleteUrl = transactionConfig.sop.org.safetyOrg.delete.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    add() {
      this.grid.data.splice(0, 0, {
        id: uid(),
        parentId: '',
        jobName: '',
        level: 0,
        sortOrder: 0,
        connectionFlag: 'N',
        multipleFlag: 'N',
        remark: '',
        regUserId: this.$store.getters.user.userId,
        chgUserId: this.$store.getters.user.userId,
        editFlag: 'C',
      })
    },
    saveItem() {
      if (this.$comm.validTable(this.grid.columns, this.grid.data)) {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGSAVE', // 저장하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.isSave = !this.isSave
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getList();
    },
    removeRow() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',
          message: 'MSGREMOVE', // 삭제하시겠습니까?,
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {data: Object.values(selectData)};
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.getList();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    searchSenior(row) {
      this.popupOptions.title = 'LBL0010237'; // 선해임명 검색
      this.popupOptions.param = { type: 'single' };
      this.popupOptions.target = () => import(`${'@/pages/sop/com/seniorDismissalPop.vue'}`);
      this.popupOptions.width = '70%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = (data) => {this.closeSeniorPopup(row, data);}
    },
    closeSeniorPopup(row, data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        row.seniorName = data[0].seniorName;
        row.seniorId = data[0].seniorId;
        this.dataChange(row);
      }
    },
    removeSenior(row) {
      row.seniorName = null;
      row.seniorId = null;
      this.dataChange(row);
    },
    dataChange(row) {
      if (row['editFlag'] !== 'C') {
        row['editFlag'] = 'U'
        row['chgUserId'] = this.$store.getters.user.userId
      }
    }
  }
};
</script>
